import { type ChangeEvent } from 'react';

// Types ----

type LocaleSelectProps = {
  id?: string;
  value?: string | null;
  onChange: (lengthUnit: string) => void;
  required?: boolean;
};

// Component ----

function LengthUnitSelect({ id, value, onChange, required = false }: LocaleSelectProps) {
  function handleSelect(event: ChangeEvent<HTMLSelectElement>) {
    onChange(event.target.value);
  }

  return (
    <select
      id={id}
      value={value || 'imperial'}
      onChange={handleSelect}
      className="flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-md sm:text-sm border-gray-300"
      required={required}
    >
      <option value="imperial">Imperial</option>
      <option value="metric">Metric</option>
    </select>
  );
}

export default LengthUnitSelect;
